export default "__VITE_ASSET__BoWRTqWB__"